import { className } from 'postcss-selector-parser';

import FreeQuoteButton from './button/freequoteButton';
import React from 'react';
import grass1 from '../../img/grass1.jpg';

const FreeQuoteBlockLarge =() =>{
    return <div>
        <div className=" row">
            <div className="col s12 m12">
                <div className=" large card hide-on-med-and-down">
                    <div className ="card-image">
                        <img className ="responsive-img" className="" src={grass1}></img>
                    </div>
                    <div className="card-content">
                        <span className="card-title">Free Quote</span>
                        <p>Give us a call or send us an email for a free quote.</p>
                    </div>
                    <div className ="card-action">
                        <FreeQuoteButton></FreeQuoteButton>
                    </div>
                </div>
            </div>
        </div>


        <div className="col s6 m7">
                <div className="hide-on-med-and-up card">
                    <div className ="card-image">
                        <img className="responsive-img" src={grass1}></img>   
                    </div>
                    <div className="card-content">
                        <span className="card-title">Free Quote</span>
                        <p>Give us a call or send us an email for a free quote.</p>
                    </div>
                    <div className ="card-action">
                        <FreeQuoteButton></FreeQuoteButton>
                    </div>
                </div>
        </div>
    </div>
}

export default FreeQuoteBlockLarge;